<template>
    <div class="famousTeacher">
        <div class="banner" v-if="banner">
            <video :src="banner.name" :autoplay="true" muted v-if="banner.type == 'mp4'"></video>
            <img :src="banner.name" alt="" v-else>
        </div>
        <div class="tag clearfix">
            <div class="left fl">
                <img src="../../assets/famous_logo.png" alt="" class="logo">
                名师馆
            </div>      
            <div class="right fr">
                <img src="../../assets/famous_icon1.png" alt="" class="icon">
                多重筛选
                <img src="../../assets/famous_icon2.png" alt="" class="icon">
                名师高徒
                <img src="../../assets/famous_icon3.png" alt="" class="icon">
                专业方向
                <van-icon name="arrow" color="#8E8D93" />
            </div>
        </div>

        <div class="tabBox">
            <van-tabs background="#F1F0F5" color="#01C2C3" @change="changeTab" sticky title-active-color="#01C2C3" title-inactive-color="#9B9AA0">
                <van-tab v-for="(item,index) in typeList" 
                    :title="item.name" 
                    :name="item.id"
                    :key="index" 
                    >
                    <van-list v-model="loading" :finished="finished" @load="onLoad" :finished-text="teacherList.length === 0 && status === 'nomore' ? '' : '没有更多了'">
                        <template v-for="(teacher, teacherIndex) in teacherList">
                        <div class="teacher" :key="teacherIndex">
                            <div class="left">
                                <div class="pic">
                                    <van-image style="width: 22.4vw;height: 22.4vw;" :src="teacher.teacherIconPicUrl">
                                        <template v-slot:error>
                                            <img style="width: 22.4vw;height: 22.4vw;" src="https://oss.dayulong.cn/mini/figure.png" alt="">
                                        </template>
                                    </van-image>
                                    <!-- <img :src="teacher.teacherIconPicUrl" alt=""> -->
                                </div>
                                <div class="info">
                                    <div class="name">{{teacher.courseName}}</div>
                                    <div class="price">
                                        <span>课价</span>
                                        <span style="font-weight:bold;margin-left:2px">￥</span>
                                        <span  style="font-size:18px;font-weight:bold;color: #2D2C3C;">{{teacher.coursePrice}}</span>
                                        <img src="../../assets/coin.png" alt="" class="coin">
                                    </div>
                                </div>
                            </div>
                            <div class="right" @click="backTo(teacher.teacherUserId)">
                                <div class="name">{{teacher.teacherName}}</div>
                                <div class="cate">
                                    <template v-for="cate in teacher.teacherCate">
                                        <span :key="cate">{{cate}}</span>
                                    </template>
                                </div>
                                <div class="btn">查看主页</div>
                            </div>
                        </div>
                        </template>
                    </van-list>
                </van-tab>
                <div class="nodata" v-show="teacherList.length === 0 && status === 'nomore'">
                    <div style="width: 150px;height: 150px;" id="nodata"></div>
                    <p>暂无数据</p>
                </div>
            </van-tabs>
            
        </div>
    </div>
</template>

<script>
import lottie from 'lottie-web';
import { Icon  } from 'vant'
import { Tab, Tabs, Toast, List, Swipe, SwipeItem, Image  } from 'vant';
import { dictionaries, famousList } from '@/api/famousTeacher'

export default {
    components: { 
        vanIcon: Icon,
        vanTab: Tab,
        vanTabs: Tabs,
        vanList: List,
        vanSwipe: Swipe,
        vanSwipeItem: SwipeItem,
        vanList: List,
        vanImage: Image,
        Toast
    },
    data(){
        return {
            banner: null,
            loading: false,
            finished: false,
            typeList: [],
            page: 0,
            CateId: null,
            cityId: null,
            teacherList: [],
            terminal: null,
            status: 'loadmore'
        }
    },
    mounted(){
        this.init()

        this.terminal = this.$route.query.terminal 
        if(this.terminal == 5){
            const query = this.$route.query.jsonQuery ? JSON.parse(this.$route.query.jsonQuery) : {}
            this.cityId = query.cityId
        } else {
            this.getCityId()
        }
    },
    created(){
        dictionaries({type:'shopCategory'}).then(res=>{
            if(res.code == 200){
                this.typeList = res.data
                this.typeList.unshift({
                    id: -1,
                    name:"精选"
                })
                this.CateId = res.data[0].id
            } else {
                Toast(res.msg)
            }
        })
        dictionaries({type:'FamousTeacherHeader'}).then(res=>{
            if(res.code == 200){
                res.data.map(el=>{
                    if(el.name.indexOf('mp4') !== -1){
                        el.type = 'mp4'
                    } else {
                        el.type = 'img'
                    }
                })
                this.banner = res.data[0]
            }
        })
    },
    methods: {
        init() {
            lottie.loadAnimation({
                container: document.getElementById('nodata'),
                renderer: 'svg',
                autoplay: true,
                loop: true,
                path: 'https://oss.dayulong.cn/mini/nodata.json'
            })
        },
        // 约定APP方法-获取城市id
        getCityId(){
            DYL.getCityInfo(window['success']=(data)=>{
                if (typeof data != 'object') {
                    data = JSON.parse(data);
                }
                this.cityId = data.cityId
            })
        }, 
        changeTab(name){
            this.finished = false
            this.CateId = name,
            this.page = 1
            this.getFamousList()
        },
        getFamousList(){
            this.status = 'loading'
            famousList({
                SkipCount: (this.page -1) * 10,
                MaxResultCount: 10,
                CateId: this.CateId == -1 ? 0 : this.CateId,
                CityId: this.cityId 
            }).then(res=>{
                if(res.code == 200){
                    if(res.data.items&&res.data.items.length>1){
                        this.loading = false
                        res.data.items.map(el=>{
                            el.teacherCate = el.teacherCate.split(',')
                        })
                        if(this.page == 1){
                            this.teacherList = res.data.items
                        } else {
                            this.teacherList = this.teacherList.concat(res.data.items)
                        }
                        if(res.data.items.length<10){
                            this.finished = true
                        }
                        // this.page += 1
                    } else {
                        if(this.page == 1){
                            this.teacherList = []
                        }
                        this.finished = true
                    }

                    if (res.data.items.length < 10) {
                        this.status = 'nomore'
                    } else {
                        this.status = 'loadmore'
                    }
                }
            })
        },
        onLoad(){
            setTimeout(()=>{
                this.page+=1
                this.getFamousList()
            },500)
        },
        backTo(teacherUserId){
            if(this.terminal == 5){
                uni.navigateTo({
                    url: `/pagesA/teacher/detail?teacherUserId=${teacherUserId}&cateId=${this.CateId}`
                });
            } else {
                let paramsJson = {
                    newUrl: `dayulong://www.dylapp.cn/app/TeacherDetail?teacheruserid=${teacherUserId}&cateid=${this.CateId}`,
                    newTitle: '老师详情'
                }
                DYL.backWebViewTo(JSON.stringify(paramsJson))
            }
        }
    }
}
</script>


<style lang="scss">
    .famousTeacher {
        min-height: 100vh;
        background: #F1F0F5;
        .nodata {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 50px;
        }
        .banner {
            width: 100%;
            height: 45.8vw;
            position: relative;
            img, video {
                width: 100%;
                height: 45.8vw;
                object-fit: cover;
                object-position: center center;
            }
        }
        .tag {
            margin: 20px 16px 0px;
            background: #fff;
            padding: 9px 6px;
            .left {
                display: flex;
                align-items: center;
                color: #1F1F1F;
                font-size: 14px;
            }
            .logo {
                width: 5vw;
                height: 5vw;
                margin-right: 5px;
            }
            .right {
                padding-top: 2px;
                font-size: 12px;
                color: #8E8D93;
                .icon {
                    width: 2.6vw;
                    height: 2.9vw;
                    margin-left: 5px;
                }
            }
        }
        .teacher {
            background: #fff;
            margin-top: 12px;
            display: flex;
            .left {
                padding: 15px 16px;
                box-sizing: border-box;
                display: flex;
                width: 68vw;
                .pic {
                    width: 22.4vw;
                    height: 22.4vw;
                    margin-right: 10px;
                    border-radius: 4px;
                    background: #F1F0F5;
                    text-align: center;
                    img {
                        max-width: 22.4vw;
                        max-height: 22.4vw;
                        border-radius: 4px;
                    }
                }
                .info {
                    position: relative;
                    .name {
                        width: 33vw;
                        display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
                        font-size: 14px;
                        line-height: 20px;
                        color: #1F1F1F;
                    }
                    .price {
                        position: absolute;
                        bottom: 0;
                        span {
                            font-size: 12px;
                        }
                        .coin {
                            width: 9px;
                            height: 14.6px;
                            margin-left: 3px;
                        } 
                    }
                }
            }
            .right {
                background: #2D2C3C;
                height: calc(22.4vw +30px);
                flex: 1;
                text-align: center;
                .name {
                    font-size: 16px;
                    font-weight: 800;
                    color: #63F5F9;
                    margin: 20px 0 9px;
                }
                .cate {
                    span {
                        color: #B7B6C6;
                        border: 1px solid #B7B6C6;
                        font-size: 10px;
                        padding: 1px 3px;
                        margin-right: 3px;
                    }
                    span:last-child{
                        margin-right: 0;
                    }
                }
                .btn {
                    width: 60px;
                    line-height: 21px;
                    background: #00CBCC;
                    color: #fff;
                    font-size: 12px;
                    margin: 10px auto 0;
                }
            }
        }
    }
</style>